var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"name":_vm.name,"custom":"","persistent":""}},[_c('WarRoomOnboardingJobSearch',{staticClass:"war-room-onboarding-job-search-modal",attrs:{"next-route":_vm.nextRoute,"step":2,"step-count":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }